<div [class]="'flex flex-col gap-(--gap-normal) ' + class">
  @if (!floatLabel) {
    @if (effectiveLabel) {
      <label [for]="id" [class]="(boldLabel ? 'font-bold ' : '') + labelClass">
        {{ effectiveLabel }}
        @if (effectiveRequired) {
          <sup>*</sup>
        }
        @if (supLabel) {
          <sup>{{ supLabel }}</sup>
        }
      </label>
    }
    <ng-container [ngTemplateOutlet]="hourpickerTemplate" />
  } @else {
    <p-floatlabel variant="on">
      <ng-container [ngTemplateOutlet]="hourpickerTemplate" />
      <label [for]="id">
        {{ effectiveLabel }}
        @if (effectiveRequired) {
          <sup>*</sup>
        }
        @if (supLabel) {
          <sup>{{ supLabel }}</sup>
        }
      </label>
    </p-floatlabel>
  }

  <ces-validation-errors [errorMessages]="activeErrorMessages" [hasErrors]="hasErrors" [touched]="touched" [dirty]="dirty" />

  <ces-hourpicker-field-debug-panel
    [value]="value"
    [errors]="errors"
    [errorMessages]="activeErrorMessages"
    [externalErrors]="externalErrors"
    [pristine]="pristine"
    [dirty]="dirty"
    [touched]="touched"
    [valid]="valid"
    [disabled]="effectiveDisabled"
    [label]="effectiveLabel"
    [required]="effectiveRequired"
    [showSeconds]="effectiveShowSeconds"
    [minTime]="minTime"
    [maxTime]="maxTime"
    [floatLabel]="floatLabel ?? false"
    (stateChange)="onStateChange($event)"
    (valueChange)="onValueChange($event)" />
</div>

<ng-template #hourpickerTemplate>
  <ces-hourpicker
    [id]="id"
    [(ngModel)]="value"
    [disabled]="effectiveDisabled"
    [showSeconds]="effectiveShowSeconds"
    (timeChange)="onTimeChange($event)"
    #hourpickerElement
    [ngClass]="{
      'ng-invalid': touched && hasErrors,
      'ng-valid': touched && !hasErrors,
      'ng-pristine': pristine,
      'ng-dirty': dirty,
      'ng-touched': touched,
      'ng-untouched': !touched,
      'ng-pending': formControl?.pending,
    }" />
</ng-template>
